/* eslint-disable no-console */
import React, { useEffect, useState, createContext, useCallback } from 'react';
import { storePromocode, getPartnerLink } from 'core/api/splitTestHelpers';
import { session } from 'core/api/storage';

const SESSION_COUPON = 'Coupon/Cart';

// TODO: Refactoring this to use a reducer and move helpers to seprate file
//Helper function
function setCookie(cname, cvalue) {
  document.cookie = cname + '=' + cvalue  + ';path=/; max-age=' + String(365*24*60*60);
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function clearReferralCookie() {
  const referralCookies = getCookie('_methodology_sign_up');
  if (referralCookies) {
    const decodedCookie = JSON.parse(decodeURIComponent(referralCookies));
    delete decodedCookie.referral_code;
    setCookie('_methodology_sign_up', encodeURIComponent(JSON.stringify(decodedCookie)));
  }
}


// Context
export const ReferralCodeContext = createContext();
export const ReferralCodeConsumer = ReferralCodeContext.Consumer;
const sessionCoupon = JSON.parse(session.getItem(SESSION_COUPON) || '{}');

// eslint-disable-next-line react/prop-types
export const ReferralCodeContextProvider = ({ children }) => {
  const [referralCode, setReferralCode] = useState(sessionCoupon);
  const [partnerCode, setPartnerCode] = useState(false);

  useEffect(() => {
    getReferralCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('refferal code hook:', referralCode);
    }, [referralCode]);

  const getReferralCode = async () => {
    const newReferralCode = await storePromocode(window.location);
    const promoCode = newReferralCode || sessionCoupon;

    if (newReferralCode) {
      session.setItem(SESSION_COUPON, JSON.stringify(newReferralCode));
    }
    const partnerLink = getPartnerLink(window.location);

    setReferralCode(promoCode);
    setPartnerCode(partnerLink);
  };

  const clearReferralCode = useCallback(() => {
    clearReferralCookie();
    setReferralCode(null);
  },[]);

  return (
    <ReferralCodeContext.Provider value={{ referralCode, clearReferralCode, partnerCode }}>
      {children}
    </ReferralCodeContext.Provider>
  );
};
